import React, { useCallback } from 'react';
import moment from 'moment'

//Hooks
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

//Components
import { ChevronRight } from 'react-feather';
import Icon from '../Icon/Icon'

import { ROUTER_URL } from '../../const/ROUTER_URL';

//Styles
import Styles from './Reservation.module.scss';

const Reservation = ({ reservation, type, past }) => {

    const companyLogo = useSelector(state => state.companies.selectedCompany.company.company_logo);
    const companyName = useSelector(state => state.companies.selectedCompany.company.name);
    const history = useHistory();
    const { t } = useTranslation('common');

    const {
        minutes,
        id,
        service,
        timestamp,
        is_recurring: isRecurring,
        bundle_name: bundleName,
        usages,
        max_usages: maxUsages,
        length,
        length_type: lengthType
    } = reservation;

    const handleDetailsRedirect = useCallback(() => {
        history.push(ROUTER_URL.RESERVATIONS_DETAILS_TYPE_ID_NEXT({
            reservationType: type,
            reservationId: id,
            next: Number(!past),
        }));
    }, [
        history,
        type,
        id,
        past,
    ]);

    return (
        <button
            onClick={handleDetailsRedirect}
            className={Styles.reservation}
            data-testid={`data-test-reservation-${id}`}
        >
            <div className={[Styles.reservationInfo, past ? Styles.past : ''].join(' ')}>
                <div className={Styles.companyInfo}>
                    <div style={{ position: 'relative' }}>
                        {
                            isRecurring ?
                                <div className={Styles.reccuring}>
                                    <Icon name="recurring" color="#fff" size={15}/>
                                </div> :
                                null
                        }
                        {
                            past ?
                                <div className={Styles.imgPastCover}>
                                    {isRecurring ? <div className={Styles.reccuringCover}/> : null}
                                </div> :
                                null
                        }
                        <img alt={'Company logo'} className={Styles.img} src={companyLogo}/>
                    </div>
                    <span 
                        data-testid={`data-test-company-${companyName}`}
                        style={{ fontSize: '17px', textAlign: 'left' }}
                    >
                        <strong>{companyName}</strong>
                    </span>
                </div>
                <div className={Styles.reservationDetails}>
                    {
                        type === 'product' ?
                            <div className={Styles.details}>
                            <span data-testid={'data-test-date'}>
                                {
                                    `${moment.unix(timestamp).utc().format('ddd D MMMM')}, ${moment.unix(timestamp).utc().format('HH:mm')} - ${moment.unix(timestamp).utc().add(minutes, 'minutes').format('HH:mm')}`
                                }
                            </span>
                                <span data-testid={'data-test-service'}>
                                    {service}
                                </span>
                            </div> :
                            <div className={Styles.details}>
                            <span>
                                {t('reservationsScreen.reservation.bundle', { bundleName })}
                            </span>
                                <span>
                                {
                                    t(`reservationsScreen.reservation.${maxUsages ? 'quantity' : 'used'}`, {
                                        usages,
                                        maxUsages
                                    })
                                }
                            </span>
                                <span>
                                {
                                    length === '∞'
                                        ? `${t('reservationsScreen.reservation.doNotExpire')}`
                                        : `${t('reservationScreen.expiresIn')} ${lengthType && lengthType !== null ? t(`reservationScreen.${lengthType.split('.')[2]}`, { count: length }) : length}`
                                }
                            </span>
                            </div>
                    }
                </div>
            </div>
            <div className={Styles.chevron}>
                <ChevronRight size={28}/>
            </div>
        </button>
    )

};

export default Reservation
